/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/12
 */
import React from 'react';

const CircleClose = () => {
  return <svg viewBox="0 0 1024 1024" className="store-svg-circleclose">
    <path d="M512 46.645c125.647 0 241.984 46.537 330.403 134.957 181.49 181.49 181.49 474.659 0 656.153-88.416 93.069-204.761 139.609-330.403 139.609-125.647 0-241.984-46.537-330.403-134.957-181.49-181.49-181.49-474.659 0-656.153 88.416-93.069 204.761-139.609 330.403-139.609M512 0.112c-130.302 0-260.602 51.188-362.976 148.916-200.102 200.102-200.102 525.856 0 725.952 97.724 97.724 232.675 148.916 362.976 148.916s260.602-51.188 362.976-148.916c200.102-200.102 200.102-525.856 0-725.952-102.375-97.724-232.675-148.916-362.976-148.916v0z"/>
    <path d="M331.001 660.069l329.053-329.053 32.907 32.907-329.053 329.053-32.907-32.907z"/>
    <path d="M363.931 331.001l329.053 329.053-32.907 32.907-329.053-329.053 32.907-32.907z"/>
  </svg>
};

export default CircleClose;



// WEBPACK FOOTER //
// ./src/svgs/circleClose.js